export default {"src":"/_next/static/media/SpinalCordInjuries.2a69c70a.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};